import { render, staticRenderFns } from "./LomCreate.vue?vue&type=template&id=5d3fadb0"
import script from "./LomCreate.vue?vue&type=script&lang=js"
export * from "./LomCreate.vue?vue&type=script&lang=js"
import style0 from "./LomCreate.vue?vue&type=style&index=0&id=5d3fadb0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports